import * as types from "../types/orderManagement.types";

const initialState = {
  taskListData: [],
  taskPagination: [],
  taskDetailData: [],
  taskIssueData: [],
  orderCancelConfirmationData: [],
};

const OrderManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ORDER_MANAGEMENT_TASK_LIST_DATA:
      return { ...state, taskListData: action.payload };
    case types.SET_ORDER_MANAGEMENT_TASK_LIST_PAGINATION_DATA:
      return { ...state, taskPagination: action.payload };
    case types.SET_ORDER_MANAGEMENT_TASK_DETAIL_DATA:
      return { ...state, taskDetailData: action.payload };
    case types.SET_ORDER_MANAGEMENT_TASK_ISSUE_DATA:
      return { ...state, taskIssueData: action.payload };
    case types.SET_ORDER_CANCEL_CONFIRMATION:
      return { ...state, orderCancelConfirmationData: action.payload };
    case types.RESET_ORDER_MANAGEMENT_REDUCER:
      return {
        ...state,
        taskListData: [],
        taskPagination:[],
        taskListpaginationData: [],
        taskDetailData: [],
        taskIssueData: [],
      };
    default:
      return state;
  }
};
export default OrderManagementReducer;
